import React from 'react';
import styled from 'styled-components';
import { getColumnMapping } from './worker';
import { faArrowRight, faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import ContributionMappingRow from './ContributionMappingRow';
import ContributionMappingColumn, {
  ReactChild,
} from './ContributionMappingColumn';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface RowProps {
  columnOne: {
    heading: ReactChild;
    subheading?: ReactChild;
    error?: boolean;
  };
  columnTwo?: IconDefinition | IconProp;
  columnThree: {
    value?: string;
    error?: boolean;
  };
}

const Row: React.FC<RowProps> = ({ columnOne, columnTwo, columnThree }) => {
  return (
    <ContributionMappingRow
      columnOne={
        <ContributionMappingColumn
          type="column"
          heading={columnOne.heading}
          subheading={columnOne.subheading}
          error={columnOne.error}
        />
      }
      columnTwo={columnTwo}
      columnThree={
        <ContributionMappingColumn type="value" error={columnThree?.error}>
          <TrueImpactTextfield
            disabled={true}
            value={columnThree?.value}
            placeholder={columnThree?.value || 'Unknown'}
          />
        </ContributionMappingColumn>
      }
    />
  );
};

interface ContributionMappingRowsProps {
  data: string[][];
  columns: ReturnType<typeof getColumnMapping>;
}

const StyledDiv = styled.div``;

const ContributionMappingRows: React.FC<ContributionMappingRowsProps> = ({
  data,
  columns,
}) => {
  const isValid = columns.missingColumns.length === 0;
  return (
    <StyledDiv>
      {columns.columns.map((d, i) => (
        <Row
          key={d}
          columnOne={{
            heading: d,
            subheading: `(e.g. ${data[1][i]})`,
          }}
          columnTwo={faArrowRight}
          columnThree={{ value: columns.resultMapping[d]?.systemColumnName }}
        />
      ))}
      {columns.missingColumns.map(x => (
        <Row
          key={x}
          columnOne={{
            heading: (
              <TrueImpactText color="critical" className="missing-column">
                Missing Column
              </TrueImpactText>
            ),
            error: true,
          }}
          columnTwo={faArrowLeft}
          columnThree={{ value: x }}
        />
      ))}
      {/* {columns.extraColumnIndexes.map(x => (
        <Row
          key={x.name}
          columnOne={{
            heading: x.name,
            subheading: `(e.g. ${data[1][x.index]})`,
          }}
          columnTwo={faArrowRight}
          columnThree={{ error: !isValid }}
        />
      ))} */}
    </StyledDiv>
  );
};

export default ContributionMappingRows;
